import { gql } from '@apollo/client';

export default gql(`
    mutation DeleteCard($input: DeleteCardInput!) {
        deleteCard(input: $input)
    }
`);
